const calculateMinMaxPersonsCountForQuantity = ({ quantity, item: { min_persons_count, max_persons_count } }) => {
  const min = Math.min((quantity || 0) * (min_persons_count || 0), 40)
  const max = Math.min((quantity || 0) * (max_persons_count || 30), 40)
  return { min, max }
}

const calculatePossibleOrderedItemValues = (order, orderedItem) => {
  const item = orderedItem.product_pricelist_item
  const minQuantity = order.product_variant.min_order_stock_count || 0
  const maxQuantity = Math.min(
    (order.data.booking_type === "no_booking"
      ? (order.product_variant.nb_total_stock_left === null
        ? Infinity
        : order.product_variant.nb_total_stock_left)
      : Infinity),
    order.product_variant.max_order_stock_count || 40
  )
  
  const showQuantityInput = item.pricelist_type !== "pricelist_by_person"
  const showPersonsCountInput = (item.min_persons_count !== null || item.max_persons_count !== null)

  const possibleQuantities = _([
    0,
    ...__range__(minQuantity, maxQuantity, true)
  ]).uniq().value()
  let possiblePersonsCounts = []

  if (!showQuantityInput && showPersonsCountInput) {
    possiblePersonsCounts = _(
        possibleQuantities.map(quantity => {
          const { min, max } = calculateMinMaxPersonsCountForQuantity({ quantity, item })
          return __range__(min, max, true)
        })
      )
      .flatten()
      .uniq()
      .sortBy()
      .value()
  } else if (showQuantityInput && showPersonsCountInput && orderedItem.quantity) {
    const { min, max } = calculateMinMaxPersonsCountForQuantity({ quantity: orderedItem.quantity, item })
    possiblePersonsCounts = __range__(min, max, true)
  }

  return { showQuantityInput, showPersonsCountInput, possibleQuantities, possiblePersonsCounts }
}

export default class OrderedProductPricelistItemFormRow extends React.Component {
  handlePropChange(prop, value) {
    const { order, orderedItem, onChange } = this.props
    const { showQuantityInput, showPersonsCountInput } = calculatePossibleOrderedItemValues(order, orderedItem)
    const item = orderedItem.product_pricelist_item
    let nextOrderedItem = {
      ...orderedItem,
      quantity: showQuantityInput ? orderedItem.quantity : undefined,
      persons_count: showPersonsCountInput ? orderedItem.persons_count : undefined,
      [prop]: value,
    }
    const { possibleQuantities, possiblePersonsCounts } = calculatePossibleOrderedItemValues(order, nextOrderedItem)
    // if (possibleQuantities.indexOf(nextOrderedItem.quantity) === -1) {
    //   nextOrderedItem.quantity = possibleQuantities[possibleQuantities.length - 1]
    // }
    if (showPersonsCountInput && possiblePersonsCounts.indexOf(nextOrderedItem.persons_count) === -1) {
      nextOrderedItem.persons_count = possiblePersonsCounts[0]
    }
    onChange(nextOrderedItem)
  }

  render() {
    const { order, orderedItem } = this.props
    const { showQuantityInput, showPersonsCountInput, possibleQuantities, possiblePersonsCounts } = calculatePossibleOrderedItemValues(order, orderedItem)
    const item = orderedItem.product_pricelist_item

    if (item.pricelist_type === "pricelist_by_order") {
      return (
        <div className="form-group">
          <div className="form-label">
            {item.display_name}
          </div>
          <div className="form-wrapper">
            {orderedItem.total_price && st.formatMoney( st.exchangeMoney(orderedItem.total_price, order.data.customer_conversion_currency) )}

            {showPersonsCountInput && possiblePersonsCounts.length > 0 && (
              <span>
                &nbsp; &nbsp; &nbsp;
                {I18n.t("attributes.persons_count")}:
                &nbsp;&nbsp;
                <select
                  className="form-control form-control-inline"
                  id={`NewOrderProductForm-pricelist_items-${item.id}-persons_count`}
                  value={orderedItem.persons_count || 0}
                  onChange={event => this.handlePropChange("persons_count", +event.target.value)}>
                  {possiblePersonsCounts.map(i =>
                    <option key={i} value={i}>{i}</option>
                  )}
                </select>
              </span>
            )}
          </div>
        </div>
      )
    }

    return (
      <div className="form-group form-group-checkbox" key={item.id}>
        <label className="form-label" htmlFor={`NewOrderProductForm-pricelist_items-${item.id}-${showQuantityInput ? 'quantity' : 'persons_count'}`}>
          <div className="control-label">
            {item.display_name}
          </div>
          <div className="help">
            {st.formatMoney( st.exchangeMoney(item.price, order.data.customer_conversion_currency) )}
            {item.price_type == "price_per_person" && I18n.t("attributes.x_price_per_person", {x: ""})}
            {item.price_type == "price_per_item" && I18n.t("attributes.x_price_per_item", {x: ""})}
          </div>
        </label>
        <div className="form-wrapper">
          {showQuantityInput && (
            <select
              className="form-control form-control-inline"
              id={`NewOrderProductForm-pricelist_items-${item.id}-quantity`}
              value={orderedItem.quantity || 0}
              onChange={event => this.handlePropChange("quantity", +event.target.value)}>
              {possibleQuantities.map(i =>
                <option key={i} value={i}>{i}</option>
              )}
            </select>
          )}
          {showQuantityInput && showPersonsCountInput && possiblePersonsCounts.length > 0 && (
            <span>
              &nbsp;&nbsp;&nbsp;
              {I18n.t("attributes.persons_count")}:
              &nbsp;&nbsp;
            </span>
          )}
          {showPersonsCountInput && possiblePersonsCounts.length > 0 && (
            <select
              className="form-control form-control-inline"
              id={`NewOrderProductForm-pricelist_items-${item.id}-persons_count`}
              value={orderedItem.persons_count || 0}
              onChange={event => this.handlePropChange("persons_count", +event.target.value)}>
              {possiblePersonsCounts.map(i =>
                <option key={i} value={i}>{i}</option>
              )}
            </select>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/OrderedProductPricelistItemFormRow.jsx